import { UntypedFormControl, ValidatorFn } from '@angular/forms';

export function uniqueInValidator(values: string[]): ValidatorFn {
	return (control: UntypedFormControl) => {
		return !control || !values || values.includes(control.value) ? { uniqueIn: true } : null;
	};
}
